import { render, staticRenderFns } from "./make-paydoc-template.vue?vue&type=template&id=5f968d1e"
import script from "./make-paydoc-template.vue?vue&type=script&lang=js"
export * from "./make-paydoc-template.vue?vue&type=script&lang=js"
import style0 from "./make-paydoc-template.vue?vue&type=style&index=0&id=5f968d1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports